import React from 'react';
import PropTypes from 'prop-types';

import { Button, ClockCircleOutlineIcon } from '@metarouter-private/mr-mui';

import useAuditLogAffordanceVisible from 'app/audit-logs/useAuditLogAffordanceVisible';

const BUTTON_LABEL = 'Audit Log';
const TEST_ID = 'auditLogDetailButton';

export default function AuditLogDetailButton({ onClick }) {
  const visible = useAuditLogAffordanceVisible();
  if (!visible) return null;

  return (
    <Button startIcon={<ClockCircleOutlineIcon />} onClick={onClick} data-test-id={TEST_ID}>
      {BUTTON_LABEL}
    </Button>
  );
}

AuditLogDetailButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
